(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(list) {
    if (!list || list.dataset.asStepsInit) return;
    list.dataset.asStepsInit = '1';
    if (reduce) return; // steps stay fully visible (CSS default)

    var items = Array.prototype.slice.call(list.querySelectorAll('.as-steps__item'));
    var S = Number(list.dataset.start) || 0.85;
    var E = Number(list.dataset.end) || 0.55;
    var smooth = items.map(function () {
      return 0;
    });
    var last = items.map(function () {
      return -1;
    });
    var running = false;
    var raf = 0;

    list.setAttribute('data-reveal', 'ready'); // switches CSS default from --p:1 to --p:0

    function frame() {
      var vh = window.innerHeight || 1;
      items.forEach(function (el, i) {
        var r = el.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (S * vh - r.top) / ((S - E) * vh)));
        smooth[i] += (p - smooth[i]) * 0.14;
        if (Math.abs(p - smooth[i]) < 0.0005) smooth[i] = p;
        var v = Math.round(smooth[i] * 100) / 100;
        if (v !== last[i]) {
          last[i] = v;
          el.style.setProperty('--p', v);
        }
      });
      raf = running ? requestAnimationFrame(frame) : 0;
    }

    var io = new IntersectionObserver(
      function (entries) {
        running = entries.some(function (e) {
          return e.isIntersecting;
        });
        if (running && !raf) raf = requestAnimationFrame(frame);
      },
      { rootMargin: '30% 0px 30% 0px' }
    );
    io.observe(list);
    frame();
  }

  function boot() {
    document.querySelectorAll('[data-as-steps]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var list = e.target.querySelector('[data-as-steps]');
    if (list) {
      delete list.dataset.asStepsInit;
      init(list);
    }
  });
})();
